
import { css } from 'lit';
export default css`
.email-signup__container {
    margin-bottom: 3rem;
  }

    @media (min-width: 1024px) {.email-signup__container {
      margin-bottom: 4rem
  }
    }
  .email-signup__input {
  display: flex;
}
  .email-signup__input {
  flex-direction: row;
}
  .email-signup__input {
  justify-content: space-between;
}
  @media (min-width: 1200px) {
  .email-signup__input {
      flex-direction: column
  }
    }
  .email-signup__input-textfield {
  width: 100%;
}
  .email-signup__input-textfield {
  border-bottom-width: 1px;
}
  .email-signup__input-textfield {
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
}
  .email-signup__input-textfield {
  font-size: 1.125rem;
}
  .email-signup__input-textfield {
  font-style: italic;
}
  .email-signup__input-textfield {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}
  .email-signup__input-textfield::-moz-placeholder {
  font-size: 1.125rem;
}
  .email-signup__input-textfield:-ms-input-placeholder {
  font-size: 1.125rem;
}
  .email-signup__input-textfield::placeholder {
  font-size: 1.125rem;
}
  .email-signup__input-textfield::-moz-placeholder {
  font-style: italic;
}
  .email-signup__input-textfield:-ms-input-placeholder {
  font-style: italic;
}
  .email-signup__input-textfield::placeholder {
  font-style: italic;
}
  .email-signup__input-textfield::-moz-placeholder {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}
  .email-signup__input-textfield:-ms-input-placeholder {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}
  .email-signup__input-textfield::placeholder {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}
  .email-signup__input-heading {
  width: 100%;
}
  .email-signup__input-heading {
  padding-bottom: 0px;
}
  .email-signup__input-heading {
  padding-top: 1rem;
}
  @media (min-width: 1024px) {

  .email-signup__input-heading {
    white-space: nowrap;
  }
}
  .email-signup__input-submit {
  white-space: nowrap;
}
  .email-signup__privacy {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
  .email-signup__privacy {
  padding-top: 1.25rem;
}
  .email-signup__privacy {
  text-align: center;
}
  .email-signup__privacy {
  font-size: 0.875rem;
}
  @media (min-width: 640px) {

  .email-signup__privacy {
    padding-left: 0px;
    padding-right: 0px;
  }
}
  @media (min-width: 640px) {

  .email-signup__privacy {
    padding-top: 0.75rem;
  }
}
  @media (min-width: 640px) {

  .email-signup__privacy {
    text-align: left;
  }
}
`;